<template>
  <div>
    <a-table :scroll="{ x: 1300 }" :loading="loading" :pagination="false" :columns="columns" size="middle" :data-source="tableData" row-key="id">
      <template slot="customTitle" slot-scope="text, record">
        <a class="custom-link" :href="link(record)" target="_blank">{{ record.title }}</a>
      </template>
      <template slot="target" slot-scope="text, record">
        {{ requirementTargetMap[record.target] ? requirementTargetMap[record.target].label : '--' }}
      </template>
      <template slot="productLine" slot-scope="text, record">
        {{ productLineMap[record.productLine] ? productLineMap[record.productLine].label : '--' }}
      </template>
      <template slot="businessPartner" slot-scope="text, record">
        {{ userMap[record.businessPartner] ? userMap[record.businessPartner].nickname : '--' }}
      </template>
      <template slot="businessCorrelation" slot-scope="text, record">
        {{ record.businessCorrelation ? record.businessCorrelation.map(item => (userMap[item] ? userMap[item].nickname : '--')).join(';') : '--' }}
      </template>
      <template slot="status" slot-scope="text, record">
        <StatusTag :status="record.status" />
        <!-- <a-tag v-if="requirementStatus[record.status]" :color="requirementStatus[record.status].color"> {{ requirementStatus[record.status].label }}</a-tag>
        <a-tag v-else>{{ status }}</a-tag> -->
      </template>
    </a-table>
  </div>
</template>

<script>
import { userList } from '@/api/system/auth';
import { queryBusinessRequirement } from '@/api/business/requirement';
import { requirementTarget, requirementStatus, productLine } from '@/utils/dictionary';
import StatusTag from '@/pages/business/requirement/components/StatusTag';

const columns = [
  {
    width: 80,
    title: 'ID',
    customRender: (_, record) => 'BR-' + record.id
  },
  {
    width: 300,
    ellipsis: true,
    title: '标题',
    scopedSlots: { customRender: 'customTitle' }
  },
  {
    width: 120,
    title: '需求目的',
    key: 'target',
    dataIndex: 'target',
    scopedSlots: { customRender: 'target' }
  },
  {
    width: 130,
    ellipsis: true,
    title: '状态',
    scopedSlots: { customRender: 'status' }
  },
  {
    width: 100,
    title: '主业务方',
    scopedSlots: { customRender: 'businessPartner' }
  },
  {
    width: 160,
    title: '关联业务方',
    scopedSlots: { customRender: 'businessCorrelation' }
  },
  {
    width: 200,
    title: '涉及产品线',
    scopedSlots: { customRender: 'productLine' }
  },
  {
    width: 165,
    title: '创建时间',
    key: 'createdTime',
    dataIndex: 'createdTime'
  },
  {
    width: 165,
    title: '更新时间',
    key: 'updatedTime',
    dataIndex: 'updatedTime'
  }
];

export default {
  components: { StatusTag },
  props: {
    dataSource: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      columns,
      tableData: [],
      productLine,
      loading: false,
      requirementTarget,
      requirementStatus,
      userMap: {}
    };
  },
  computed: {
    link() {
      return record => {
        return this.$router.resolve({
          name: 'page:business:requirement:detail',
          params: { id: record.id }
        }).href;
      };
    },
    requirementTargetMap() {
      return this.requirementTarget.reduce((results, item, _) => {
        results[item.value] = item;
        return results;
      }, {});
    },
    productLineMap() {
      return this.productLine.reduce((results, item, _) => {
        results[item.value] = item;
        return results;
      }, {});
    }
  },
  watch: {
    dataSource() {
      this.getDataList();
    }
  },
  created() {
    userList({}).then(res => {
      this.userMap = res.data.users.reduce((results, item, _) => {
        results[item.id] = { id: item.id, nickname: item.nickname, avatar_url: item.avatar_url };
        return results;
      }, {});
    });
  },
  mounted() {
    if (this.dataSource.length > 0) {
      this.getDataList();
    }
  },
  methods: {
    getDataList() {
      this.loading = true;
      queryBusinessRequirement({ ids: this.dataSource, page_size: 20, page_number: 1 })
        .then(res => {
          this.tableData = res.data.items || [];
          this.$emit('countChange', this.tableData.length);
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    }
  }
};
</script>
